type Props = {
  svgProps?: React.SVGProps<SVGSVGElement>
  iconColor?: string
}

export const PhoneSVG = ({ iconColor, svgProps }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      {...svgProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.41358 0.383307C1.97017 -0.173279 2.88862 -0.116098 3.37187 0.505226L4.71715 2.23487C4.96403 2.55228 5.05126 2.96556 4.95374 3.35567L4.54329 4.99747C4.49995 5.1708 4.55074 5.35416 4.67708 5.48049L6.51951 7.32292C6.64585 7.44926 6.8292 7.50005 7.00253 7.45671L8.64433 7.04626C9.03444 6.94874 9.44772 7.03598 9.76513 7.28285L11.4948 8.62813C12.1161 9.11138 12.1733 10.0298 11.6167 10.5864L10.8413 11.3619C10.2865 11.9167 9.45666 12.1603 8.68331 11.8884C6.76316 11.2133 4.96079 10.1081 3.42637 8.57363C1.89195 7.03921 0.786712 5.23684 0.111629 3.31669C-0.160262 2.54334 0.0833476 1.71354 0.638137 1.15875L1.41358 0.383307Z"
        fill={iconColor || '#131313'}
      />
    </svg>
  )
}
